import { createStyles, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => createStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',
    paddingLeft: '0 !important',
    '& .active': {
      fontWeight: 'bold',
    },
  },
  icon: {
    color: '#747C99',
    fontSize: '1rem',
    marginRight: '7px',
  },
  greatIcon: {
    color: '#00AD8D',
  },
  goodIcon: {
    color: '#EFC400',
  },
  partiallyIcon: {
    color: '#FF6C00',
  },
  deleteIcon: {
    color: '#F8221A',
  },
}), { name: 'FeelRecordPreviewAction' });

export default useStyles;
